import Vue from 'vue'
import { createInertiaApp } from '@inertiajs/inertia-vue'

import './config-vue-use'
import './config-vue-component'
import './config-vue-prototype'
import './config-loading'

createInertiaApp({
  resolve: name => import(/* webpackChunkName: "[request]" */ `@/Pages/${name}`),
  setup({ el, App, props, plugin }) {
    Vue.use(plugin)
    new Vue({
      metaInfo: {
        titleTemplate: title => title ? `${title} - Trustee System` : 'Trustee System'
      },
      render: h => h(App, props),
    }).$mount(el)
  },
})
